<template>
  <div>
    <HeaderComponent  app_title="ECOBUQ" />
    <main>
      <EconomicForm></EconomicForm>
    </main>
    <FooterComponent class="bottom-0"></FooterComponent>
  </div>
</template>

<script>
// @ is an alias to /src
import FooterComponent from "@/components/FooterComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import EconomicForm from "@/components/EconomicForm.vue";

export default {
  name: "HomeView",
  components: {
    HeaderComponent,
    FooterComponent,
    EconomicForm
  },
  created() {},
};
</script>
<style scoped>
  .container {
    height: 100% !important;
  }
</style>
